// extracted by mini-css-extract-plugin
export var placeholder = "Image-module--placeholder--64a1e";